// モジュール読み込み
// ============================================================

//import Vue from 'vue';
import * as func from './functions/_function';                        //関数関係
import * as animation from './functions/_animation';                  //アニメーション関係
// import * as bliderBox from './functions/_bliderBox'                 //ブラインダーボックス
import * as offcanvas from './functions/_offcanvas';                  //オフキャンバス
//import * as pagetop from './functions/_pagetop';                    //ページトップ
import * as loading from './functions/_loading';                      //ローディング
import * as smoothScroll from './functions/_smoothScroll';          //スムーススクロール
import Modal from '../../node_modules/bootstrap/js/dist/modal';     //モーダルライブラリ
import 'mobile-detect';                                               //デバイス判定・ブラウザ判定ライブラリ
import * as checkUA from './functions/_checkUA';                      //デバイス判定・ブラウザ判定処理
// import 'slick-carousel';                                              //slick

// デフォルトのテーマ
import '@splidejs/splide/css';
// または、そのほかのテーマ
import '@splidejs/splide/css/skyblue';
import '@splidejs/splide/css/sea-green';

import Splide from '@splidejs/splide';
import  {AutoScroll}  from '@splidejs/splide-extension-auto-scroll';




// 定数
// ============================================================

const BLAKEPOINT_HEADER_SP_MODE = 1024;                               //ヘッダーレスポンシブブレイクポイント
const DEBUG_MODE                = false;                              //デバッグモード

// グローバル変数
// ============================================================

let CURRENT_SCROLL_POS = 0;
let LAST_SCROLL_POS = 0; //前回のスクロールポジション
let WIN_WIDTH                 = window.innerWidth;
let WIN_HEIGHT                = window.innerHeight;
let CURRENT_SC_OFFSET_X       = window.pageXOffset;
let CURRENT_SC_OFFSET_Y       = window.pageYOffset;
let SCROLLDOWN_FLAG           = true;
let elm_header = document.getElementById('globalHeader');
let elm_wrapper = document.getElementById('wrapper');
let HEADER_H = elm_header.offsetHeight;

// サイト共通関数初期化
// ============================================================

animation.scrollObserver();                                              // アニメーション処理
checkUA.addUAClass();                                                    // UAおよびデバイスクラス追加処理
//headerFixed.setHeaderFixed();                                          // ヘッダー固定
smoothScroll.setSmoothScroll();                                        // スムーススクロール
offcanvas.setOffcanvas(BLAKEPOINT_HEADER_SP_MODE,'app');  // オフキャンバス処理
loading.initLoading(DEBUG_MODE);

// イベント毎のサイト共通関数初期化
// ============================================================

window.addEventListener('scroll', () => {
  CURRENT_SC_OFFSET_X = window.pageXOffset;
  CURRENT_SC_OFFSET_Y = window.pageYOffset;
  doScrollDirectionFlexibleHeaderFixed();
  //引数：固定,固定,ボタンを出現させるきっかけとなる要素のID名,ボタンを固定させるきっかけとなる要素のID名
  // pagetop.setScrolltopBtn(WIN_HEIGHT,CURRENT_SC_OFFSET_Y,'mv','footer');
})

window.addEventListener('resize', () => {
  WIN_WIDTH = window.innerWidth;
  WIN_HEIGHT = window.innerHeight;
})

window.addEventListener('DOMContentLoaded' , () => {
  initOverFlowCarousel();
  initConveyorSlide();
  initMvSlider();
})


// ============================================================




// ------------------------------------------------------------
// Windowのスクロール量に応じてヘッダーの表示/非表示を切り替える処理
// ------------------------------------------------------------

let targetMv_H = 0;
let threshold = HEADER_H + targetMv_H;

function doScrollDirectionFlexibleHeaderFixed() {
  
  if(!document.querySelector(".js_target_mv") === null){
    targetMv_H = document.querySelector(".js_target_mv").offsetHeight;
    threshold = HEADER_H + targetMv_H;
  }
  
  if(CURRENT_SC_OFFSET_Y > threshold){
    elm_header.classList.add("moveOut");
    elm_header.classList.remove("moveIn");
  }
  
  if(CURRENT_SC_OFFSET_Y < LAST_SCROLL_POS){
    elm_header.classList.remove("moveOut");
    elm_header.classList.add("moveIn");
  }
  
  LAST_SCROLL_POS = CURRENT_SC_OFFSET_Y;
}

// ============================================================
// scrollNavのフェイドアウト処理
// ============================================================
//
// function disableScrollNav() {
//   let targetMvHeight = targetMv ? targetMv.offsetHeight : 0;
//   const elm_scrollNav = document.querySelector('.scrollNav01'); // 単一要素を取得
//   const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
//
//   // ターゲット要素の半分の高さを超えていない場合、何もしない
//   if (currentScrollTop < targetMvHeight / 2) {
//     return;
//   }
//
//   if (currentScrollTop > lastScrollTop) {
//     // 下スクロール時の処理
//     elm_scrollNav.classList.add("fadeOut");
//     elm_scrollNav.classList.remove("fadeIn");
//   } else {
//     // 上スクロール時の処理
//     elm_scrollNav.classList.add("fadeIn");
//     elm_scrollNav.classList.remove("fadeOut");
//   }
//
//   // 現在のスクロール位置を次回の比較用に保存
//   lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // モバイルや負のスクロールへの対応
// }


// ============================================================
// Splide各スライダー設定
// ============================================================



function initOverFlowCarousel(){
  // overFlowCarouselの機能
  
  var overFlowCarousel = new Splide( '.card03_slide',{
      height   : '20rem',
      wheel    : true,
      perPage  : 4,
      arrows: false,
      padding: { left: 0, right: '15.3vw',bottom: '20px' },
      gap: 20,
      pagination: false,
      breakpoints: {
        1024:{perPage:3,},
        680: {perPage: 2,},
        500: {
          perPage: 1,
          height: '22rem',
          fixedWidth :'288px',
        },
      }
    }
  );
  
  overFlowCarousel.mount();
  
  var bar    = overFlowCarousel.root.querySelector( '.my-slider-progress-bar' );


// overFlowCarouselのプログレスバーの設定
  overFlowCarousel.on( 'mounted move', function () {
    var end  = overFlowCarousel.Components.Controller.getEnd() + 1;
    var rate = Math.min( ( overFlowCarousel.index + 1 ) / end, 1 );
    bar.style.width = String( 100 * rate ) + '%';
  } );
}

function initConveyorSlide(){
  
  if(document.querySelector('.fullwidthSlider01')){
    let ctx = new Splide( '.fullwidthSlider01',{
      autoScroll :  {
        speed : 0.3,
        autoStart: true,
        pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
        pauseOnFocus: false
      },
      type : 'loop',
      width: '100%',
      perPage: 1,
      arrows: false,
      pagination: false,
      breakpoints :{
        430 : {
          width : '200%'
        }
      }
    }
    );
    ctx.mount({AutoScroll});
  }
}

function initMvSlider(){
  if(document.querySelector('.mv_fullWidthSlider')){
    const mv_slider = new Splide('.mv_fullWidthSlider', {
      type: 'fade',
      width: '100%',
      height: '100dvh',
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      rewind: true,
      interval: 4000, // 自動再生の間隔
      speed: 3000, //
    });
    
    
    mv_slider.on('move', function () {
      const lastElement = mv_slider.root.querySelector('.splide__slide:last-child figure')
      if (mv_slider.index === 0) {
        lastElement.classList.add('is-prev')
        return
      }
      if (lastElement.classList.contains('is-prev')) {
        lastElement.classList.remove('is-prev')
      }
    })
    
    
    mv_slider.mount();
  }
}
